import { ready } from '../global/instantiate';
import bambuserify from '../global/bambuser';
import handleBIS from './../sections/product/handleBIS';
import { productInit } from '../sections/product';
import showStickyAtc from '../sections/product/showStickyAtc';

ready(() => {
  productInit({}, (variant, productData) => {
    if (variant && productData) {
      handleBIS(variant, productData);
    }
  });
  bambuserify();
  showStickyAtc();
});
